exports = module.exports = require("../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-31069ed2","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Admin/Index.vue
// module id = 788
// module chunks = 1